/** Normalize match.league slugs from API / legacy forms. */
export function normalizeLeagueSlug(league: string | null | undefined): string {
  if (!league) return ''
  const raw = String(league).trim()
  const lower = raw.toLowerCase()

  if (lower === 'worldcup2026') return 'WorldCup2026'
  if (lower === 'premier-league' || lower === 'premierleague') return 'premier-league'
  if (lower === 'laliga' || lower === 'la-liga') return 'laliga'
  if (lower === 'serie-a' || lower === 'seriea') return 'serie-a'
  if (lower === 'bundesliga' || lower === 'bundes-liga') return 'bundesliga'
  if (lower === 'ligue1' || lower === 'liga1' || lower === 'liga-1' || lower === 'ligue-1') return 'ligue1'
  if (lower === 'champions-league' || lower === 'championsleague') return 'champions-league'

  return raw
}

export type LeagueBadgeKind = 'emoji' | 'image'

export interface LeagueBadgeInfo {
  kind: LeagueBadgeKind
  /** Country / competition emoji when kind === 'emoji' */
  emoji?: string
  /** Public URL path when kind === 'image' (react-brc /public) */
  imageSrc?: string
  label: string
}

const LEAGUE_BADGES: Record<string, LeagueBadgeInfo> = {
  'premier-league': { kind: 'emoji', emoji: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', label: 'Premier League' },
  laliga: { kind: 'emoji', emoji: '🇪🇸', label: 'La Liga' },
  'serie-a': { kind: 'emoji', emoji: '🇮🇹', label: 'Serie A' },
  ligue1: { kind: 'emoji', emoji: '🇫🇷', label: 'Ligue 1' },
  bundesliga: { kind: 'emoji', emoji: '🇩🇪', label: 'Bundesliga' },
  'champions-league': {
    kind: 'image',
    imageSrc: '/ucl-logo.png',
    label: 'Champions League',
  },
  WorldCup2026: {
    kind: 'image',
    imageSrc: '/world-cup-2026-official.png',
    label: 'World Cup 2026',
  },
}

export function getLeagueBadgeInfo(league: string | null | undefined): LeagueBadgeInfo | null {
  const slug = normalizeLeagueSlug(league)
  if (!slug) return null
  return LEAGUE_BADGES[slug] ?? null
}
